import { Icon, Menu } from "@blueprintjs/core";
import { MenuItem2 } from "@blueprintjs/popover2";
import React from "react";

import { SoccerActionLineType } from "../../types";
import { ActionLineProps, DottedLine, Shoot, SolidLine, SquiggleLine } from "../action-lines";
import { ActionSvgContainer } from "./action-svg-container";
import { ActionTypeFromPlayer } from "./hooks";
import styles from "./select-action-menu.module.scss";

const actionLineProps: ActionLineProps = {
  action: { pos: { x: 0, y: 25 }, midPoints: [], endPos: { x: 47, y: 25 }, color: "#fff" },
  strokeWidth: 2,
  animateable: false,
};

interface SoccerSelectActionMenuProps {
  actionTypeFromPlayer?: ActionTypeFromPlayer;
  handleClickAction: (action: { layerType: SoccerActionLineType }) => void;
  handleCancel?: () => void;
}

export const SoccerSelectActionMenu = ({
  actionTypeFromPlayer,
  handleClickAction,
  handleCancel,
}: SoccerSelectActionMenuProps) => {
  return (
    <div className="bp4-dark">
      <Menu className={styles.changeActionMenu}>
        {actionTypeFromPlayer !== "PLAYER_WITH_POSSESSION" && (
          <MenuItem2
            text={
              <ActionSvgContainer label="Run">
                <DottedLine {...actionLineProps} />
              </ActionSvgContainer>
            }
            onClick={() => handleClickAction({ layerType: SoccerActionLineType.SC_RUN })}
          />
        )}
        {actionTypeFromPlayer !== "PLAYER_WITHOUT_POSSESSION" && (
          <MenuItem2
            text={
              <ActionSvgContainer label="Dribble">
                <SquiggleLine {...actionLineProps} />
              </ActionSvgContainer>
            }
            onClick={() => handleClickAction({ layerType: SoccerActionLineType.SC_DRIBBLE })}
          />
        )}
        {actionTypeFromPlayer !== "PLAYER_WITHOUT_POSSESSION" && (
          <MenuItem2
            text={
              <ActionSvgContainer label="Pass">
                <SolidLine {...actionLineProps} />
              </ActionSvgContainer>
            }
            onClick={() => handleClickAction({ layerType: SoccerActionLineType.SC_PASS })}
          />
        )}
        {actionTypeFromPlayer !== "PLAYER_WITHOUT_POSSESSION" && (
          <MenuItem2
            text={
              <ActionSvgContainer label="Shoot">
                <Shoot
                  {...actionLineProps}
                  action={{ ...actionLineProps.action, endPos: { x: 43, y: 25 } }}
                  coverColor="#000"
                />
              </ActionSvgContainer>
            }
            onClick={() => handleClickAction({ layerType: SoccerActionLineType.SC_SHOT })}
          />
        )}
        {handleCancel && (
          <MenuItem2 text={<Icon role="button" icon="cross" color="#fff" size={24} />} onClick={handleCancel} />
        )}
      </Menu>
    </div>
  );
};
